type PackageMetricCardProps = {
  title: React.ReactNode;
  value: React.ReactNode;
};

const PackageMetricCard: React.FC<PackageMetricCardProps> = ({title, value}) => {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-2.5 rounded-lg bg-gray-02 p-3">
      <span className="text-body-sm text-gray-08">{title}</span>
      <span className="text-subtitle-lg text-neutral-fg">{value}</span>
    </div>
  );
};

export default PackageMetricCard;
